module.exports = __webpack_public_path__ + "static/media/ru_call_true.05764e6a.mp3";